import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import moment from "moment";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import { Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import CloudIcon from "assets/svgs/cloud_icon";
import * as XLSX from "xlsx";
import { formatDate, getCurrentUserRole, isDownloadDisabled } from "modules/utilities/utility";

function StatsInputData({
  setStartDateFilter,
  setEndDateFilter,
  downloadStatsData,
}) {
  const [startDate, setStartDate] = useState(
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState(new Date());

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate("");
  };
  const handleResetEndDate = () => {
    setEndDate("");
  };

  let filterLineData = downloadStatsData?.data
    ?.reduce((accumulator, val) => {
      const date = val?._id?.date;
      const index = accumulator.findIndex((obj) => obj.date === date);
      if (index !== -1) {
        accumulator[index].scales += val.value;
        const statusIndex = accumulator[index].status.findIndex(
          (obj) => obj.type === val._id.status
        );
        if (statusIndex !== -1) {
          accumulator[index].status[statusIndex].count += 1;
        } else {
          accumulator[index].status.push({ type: val._id.status, count: 1 });
        }
      } else {
        accumulator.push({
          date,
          scales: val.value,
          status: [{ type: val._id.status, count: 1 }],
        });
      }
      return accumulator;
    }, [])
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  const downloadData = () => {
    const workbook = XLSX.utils.book_new();

    // Loop through the filterLineData array and update the status counts
    const statusCountsByDate = {};
    filterLineData?.forEach(datum => {
      const statusCounts = {
        Open: 0,
        Closed: 0,
        Pending: 0,
        Resolved: 0,
      };
      datum?.status?.forEach((status) => {
        statusCounts[status?.type] += status?.count;
      });
      statusCountsByDate[datum.date] = statusCounts;
    });

    // Create an array of arrays to represent the data for the worksheet
    const worksheetData = [
      ["Date", "Scales", "Open", "Closed", "Pending", "Resolved"],
      ...filterLineData?.map((datum) => [
        datum?.date,
        datum?.scales,
        statusCountsByDate[datum.date].Open,
        statusCountsByDate[datum.date].Closed,
        statusCountsByDate[datum.date].Pending,
        statusCountsByDate[datum.date].Resolved,
      ]),
    ];
    const worksheet2Data = downloadStatsData?.data?.map((datum) => {
      return {
        ...datum._id,
        createdAt: moment(datum?._id?.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        updatedAt: moment(datum?._id?.updatedAt).format("YYYY-MM-DD HH:mm:ss"),
      };
    });
    // Convert filterData object to an array of arrays
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const worksheet2 = XLSX.utils.json_to_sheet(worksheet2Data);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Ticket Stats");
    XLSX.utils.book_append_sheet(workbook, worksheet2, "Ticket Details");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, "stats.xlsx");
  };

  function convertToEncodedFormat(dateString) {
    const moment = require("moment");

    const formattedDate = moment(dateString, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
      .utcOffset("+0530")
      .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
      .replace(/[:+]/g, (match) => encodeURIComponent(match))
      .replace("%3A", ":")
      .replace("%2B", "+");

    return formattedDate;
  }

  function convertToEncodedFormat(dateString) {
    const moment = require("moment");

    const formattedDate = moment(dateString, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
      .utcOffset("+0530")
      .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
      .replace(/[:+]/g, (match) => encodeURIComponent(match))
      .replace("%3A", ":")
      .replace("%2B", "+");

    return formattedDate;
  }

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setStartDateFilter(
      convertToEncodedFormat(
        new Date(startDate).toDateString() + " 00:59:59 GMT+0530"
      )
    );
    setEndDateFilter(
      convertToEncodedFormat(
        new Date(endDate).toDateString() + " 23:59:59 GMT+0530"
      )
    );
  };

  return (
    <div className="d-flex justify-content-end">
      <Form onSubmit={handleFilterSubmit} className="data-filter">
        <div className="d-flex gap-2">
          <Form.Group>
            <div className="input-container mt-1">
              {startDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                placeholderText="Start Date"
                dateFormat="dd-MM-yyyy"
                value={startDate ? formatDate(startDate) : ""}
                className="input-with-icon"
              />
              {startDate && (
                <span className="reset-icon" onClick={handleResetStartDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <div className="input-container mt-1">
              {endDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                placeholderText="End Date"
                dateFormat="dd-MM-yyyy"
                value={endDate ? formatDate(endDate) : ""}
              />
              {endDate && (
                <span className="reset-icon" onClick={handleResetEndDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>

          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fs-1">Filter by Date</div>
              </Tooltip>
            }
          >
            <Button
              variant="primary"
              className="mt-1 float-end w-25 h-25"
              type="submit"
            >
              Filter
            </Button>
          </OverlayTrigger>
          <div className="d-flex justify-content-center">
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  <div className="fs-1">Download Data</div>
                </Tooltip>
              }
            >
              <Button
                type="primary"
                onClick={downloadData}
                size="medium"
                className="mt-1"
                disabled={
                  isDownloadDisabled ||
                  !filterLineData ||
                  filterLineData?.length === 0 ||
                  !["admin"].includes(getCurrentUserRole())
                }
              >
                <div>
                  <CloudIcon />{" "}
                </div>
              </Button>
            </OverlayTrigger>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default StatsInputData;
